/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Granite Bagas
*/

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import * as Layout from '@components/screen/Layout';
import { isWeb, fullWidth } from '@global/screens';
import { parseDate } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';
import StatusBadge from '@components/global/StatusBadge';
import Image from '@components/global/Image';
import { setTempData } from '@/store/global';
import Table from '@components/table/Table';
import TableMobile from '@components/table/TableMobile';
import store from '@/store';

const productTableStructure = {
  product_image: {
    head: 'Image',
    body: 'product.image',
    type: 'image',
  },
  product_name: {
    head: 'Name',
    body: 'product_name',
    type: 'slot',
  },
  product_stock: {
    head: 'Stock',
    body: 'stock_available',
    type: 'slot',
  },
};

const logTableStructure = {
  date: {
    head: 'Date',
    body: 'date',
    type: 'slot',
  },
  image: {
    head: 'Image',
    body: 'product.image',
    type: 'image',
  },
  name: {
    head: 'Product Name',
    body: 'product.name',
  },
  add: {
    head: 'Add',
    body: 'add',
    type: 'slot',
  },
  return: {
    head: 'Return',
    body: 'return',
    type: 'slot',
  },
  order: {
    head: 'Order',
    body: 'order',
    type: 'slot',
  },
  status: {
    head: 'Status',
    body: 'status',
    type: 'status',
  },
};

const TABS = [
  { label: 'Product & Stock', value: 'product' },
  { label: 'Log', value: 'log' },
];

const InventorySummaryDetailScreen = (props) => {
  const dispatch = useDispatch();
  const paramsState = useSelector((state) => state.params);

  const [userData, setUserData] = useState({});
  const [products, setProducts] = useState([]);
  const [logs, setLogs] = useState([]);
  const [productSearchValue, setProductSearchValue] = useState('');
  const [logSearchValue, setLogSearchValue] = useState('');
  const [logsTotal, setLogsTotal] = useState(0);
  const [productsTotal, setProductsTotal] = useState(0);
  const [loadingPaginationProducts, setLoadingPaginationProducts] =
    useState(false);
  const [loadingPaginationLogs, setLoadingPaginationLogs] = useState(false);
  const [activeTab, setActiveTab] = useState('product');
  const [skipLog, setSkipLog] = useState(0);
  const [skipProduct, setSkipProduct] = useState(0);

  const getUserDetail = useApi(MsAccount.getUserDetail);
  const getSalesmanProducts = useApi(MsOrder.getSalesmanProducts);
  const getSalesmanProductsCount = useApi(MsOrder.getSalesmanProductsCount);
  const getSalesmanLogs = useApi(MsOrder.getSalesmanLogs);
  const getSalesmanLogsCount = useApi(MsOrder.getSalesmanLogsCount);
  const img = require('@/assets/img/default/image-default.png');

  const getUserSalesTeam = (data) => {
    const salesTeamId = props?.route?.params?.sales_team_id;
    const userSalesTeam = data?.sales_team?.find((s) => s.id == salesTeamId);
    return userSalesTeam?.name;
  };

  const getUserData = async (id) => {
    const response = await getUserDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;
      dispatch(setTempData(result.status));
      setUserData(result);
    }
  };

  const getDetail = async (id) => {
    await getUserData(id);
    await doSearchProduct();
    await doSearchLog();
  };

  const goBack = () => {
    props.navigation.replace('InventorySummaryDetailScreen', {});
    props.navigation.navigate('InventorySummaryScreen');
  };

  const finalParam = async () => {
    const params = {
      params: JSON.parse(JSON.stringify(store.getState().params)),
    };
    const keys = Object.keys(params?.params?.filter || {});
    const filter = {};
    keys.map((key) => {
      if (key == 'keyword_product' || key == 'keyword_log') {
        const stored = params.params.filter[key];
        const keyword = stored?.['$regex'] ?? stored;
        if (keyword) {
          filter['keyword'] = keyword;
          delete params.params.filter[key];
        }
      }
    });
    return {
      filter,
      params: {
        ...params,
        params: {
          ...params.params,
          filter,
        },
      },
    };
  };

  const doSearchProduct = async (val = null, newSkip = 0) => {
    setProductSearchValue(val);
    const final = await finalParam();
    const params = {
      ...final.params,
      params: {
        ...final.params.params,
        skip: newSkip,
      },
    };

    const isSearchFilter = Boolean(
      Object.keys(params?.params?.filter || {}).length,
    );
    if (isSearchFilter) {
      params.params.filter.is_search = true;
    }

    const response = await getSalesmanProducts.request(
      props.route.params.id,
      params,
    );

    if (params?.params?.skip === 0) {
      const countResponse = await getSalesmanProductsCount.request(
        props.route.params.id,
        params,
      );
      if (countResponse && countResponse.data && countResponse.data.data) {
        setProductsTotal(countResponse.data.data);
      } else {
        setProductsTotal(0);
      }
    }
    if (response?.data?.data?.length) {
      const new_response = response.data.data.map((item) => {
        if (item._id) {
          item.id = item._id;
        }
        return item;
      });
      setProducts(new_response);
    } else {
      setProducts([]);
    }
  };

  const doSearchLog = async (val = null, newSkip = 0) => {
    setLogSearchValue(val);
    const final = await finalParam();
    const params = {
      ...final.params,
      params: {
        ...final.params.params,
        skip: newSkip,
      },
    };

    const isSearchFilter = Boolean(
      Object.keys(params?.params?.filter || {}).length,
    );
    if (isSearchFilter) {
      params.params.filter.is_search = true;
    }

    const response = await getSalesmanLogs.request(
      props.route.params.id,
      params,
    );

    if (params?.params?.skip === 0) {
      const countResponse = await getSalesmanLogsCount.request(
        props.route.params.id,
        params,
      );
      if (countResponse && countResponse.data && countResponse.data.data) {
        setLogsTotal(countResponse.data.data);
      } else {
        setLogsTotal(0);
      }
    }
    if (response?.data?.data?.length) {
      const new_response = response.data.data.map((item) => {
        if (item._id) {
          item.id = item._id;
        }
        return item;
      });
      setLogs(new_response);
    } else {
      setLogs([]);
    }
  };

  const onLoadMoreProducts = (newSkip) => {
    setSkipProduct(newSkip);
    try {
      setLoadingPaginationProducts(true);
      setTimeout(async () => {
        const final = await finalParam();
        const params = {
          ...final.params,
          params: {
            ...final.params.params,
            skip: newSkip,
          },
        };
        const response = await await getSalesmanProducts.request(
          props.route.params.id,
          params,
        );
        if (response?.data?.data?.length) {
          const new_response = response.data.data.map((item) => {
            if (item._id) {
              item.id = item._id;
            }
            return item;
          });
          setProducts(products.concat(new_response));
        }
        setLoadingPaginationProducts(false);
      }, 500);
    } catch (error) {
      setLoadingPaginationProducts(false);
    }
  };

  const onLoadMoreLogs = (newSkip) => {
    setSkipLog(newSkip);
    try {
      setLoadingPaginationLogs(true);
      setTimeout(async () => {
        const final = await finalParam();
        const params = {
          ...final.params,
          params: {
            ...final.params.params,
            skip: newSkip,
          },
        };
        const response = await await getSalesmanLogs.request(
          props.route.params.id,
          params,
        );
        if (response?.data?.data?.length) {
          const new_response = response.data.data.map((item) => {
            if (item._id) {
              item.id = item._id;
            }
            return item;
          });
          setLogs(logs.concat(new_response));
        }
        setLoadingPaginationLogs(false);
      }, 500);
    } catch (error) {
      setLoadingPaginationLogs(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      dispatch(setTempData(null));
      setProducts([]);
      setLogs([]);
      setUserData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const Combination = ({ combination }) => {
    const result = [];

    // Shade
    if (combination?.attributes?.shade) {
      result.push(`Shade: ${combination?.attributes?.shade?.name}`);
    }

    // Size
    if (combination?.attributes?.size) {
      if (result.length) {
        result.push(`, Size: ${combination?.attributes?.size?.name}`);
      } else {
        result.push(`Size: ${combination?.attributes?.size?.name}`);
      }
    }

    // Variant
    if (combination?.attributes?.variant) {
      if (result.length) {
        result.push(`, Variant: ${combination?.attributes?.variant?.name}`);
      } else {
        result.push(`Variant: ${combination?.attributes?.variant?.name}`);
      }
    }

    // Non Spesify
    if (combination?.attributes?.non_specify) {
      result.push(`${combination?.attributes?.non_specify?.name}`);
    }

    if (!result.length) {
      result.push('No Attribute');
    }

    return <SociollaText>{result.join('')}</SociollaText>;
  };

  return (
    <Layout.Container>
      {getUserDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (
        <>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back
                title="Inventory Summary"
                onCallback={() => goBack()}
              />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <Layout.Wrapper rounded fullWidth>
            <View style={styles.sectionWrapper}>
              <View
                style={[
                  styles.rowContainer,
                  {
                    position: 'relative',
                    zIndex: 1,
                    justifyContent: 'space-between',
                  },
                ]}>
                <View style={styles.row}>
                  <Image
                    style={{ width: 36, height: 36, marginRight: 20 }}
                    width={36}
                    height={36}
                    isPhoto={true}
                    source={userData?.image ? userData?.image : img}
                  />
                  <View>
                    <SociollaText
                      type="medium"
                      style={{
                        fontSize: 24,
                        color: Colors.black3,
                      }}>
                      {userData?.name || '-'}
                    </SociollaText>
                    <SociollaText
                      style={{
                        fontSize: 12,
                        color: Colors.black3,
                      }}>
                      {userData?.sales_code || '-'} |{' '}
                      {getUserSalesTeam(userData) || '-'}
                    </SociollaText>
                  </View>
                </View>
              </View>
            </View>
            {!isWeb ? (
              <View style={styles.tabContainer}>
                {TABS.map((item, idx) => (
                  <TouchableOpacity
                    style={[
                      styles.tabItem,
                      item.value == activeTab ? styles.tabItemActive : {},
                    ]}
                    activeOpacity={0.8}
                    onPress={() => setActiveTab(item.value)}
                    key={idx}>
                    <SociollaText
                      type={item.value == activeTab ? 'bold' : 'medium'}
                      style={[
                        styles.tabItemText,
                        item.value == activeTab ? styles.tabItemTextActive : {},
                      ]}>
                      {item.label}
                    </SociollaText>
                  </TouchableOpacity>
                ))}
              </View>
            ) : (
              false
            )}
            {isWeb ? (
              <View
                style={{
                  width: '100%',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: Colors.grey4,
                  paddingHorizontal: 20,
                  paddingVertical: 12,
                }}>
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: isWeb ? 16 : 13,
                    letterSpacing: 0.5,
                    color: Colors.grey1,
                  }}>
                  PRODUCT
                </SociollaText>
              </View>
            ) : (
              false
            )}
            <View
              style={{
                width: '100%',
                paddingHorizontal: isWeb ? 30 : 0,
                ...(isWeb ? { paddingVertical: 20 } : {}),
              }}>
              {isWeb ? (
                <Table
                  name="product_summary"
                  structures={productTableStructure}
                  loading={getSalesmanProducts?.loading}
                  data={products}
                  searchKey="keyword_product"
                  showFilter={false}
                  searchPlaceholder="Search by name"
                  searchValue={productSearchValue}
                  searchWidth={460}
                  hasNoHide={true}
                  hasCallback={true}
                  totalData={productsTotal}
                  skip={skipProduct}
                  limit={paramsState.limit}
                  onSearch={(val) => doSearchProduct(val, skipProduct)}
                  onLoadMore={async (val) => {
                    setSkipProduct(val);
                    await doSearchProduct(productSearchValue, val);
                  }}
                  slot={{
                    last_updated_at: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        {parseDate(
                          data.last_updated_at,
                          'd MMMM yyyy | HH:mm:ss',
                        )}
                      </SociollaText>
                    ),
                    stock_available: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        {data.stock_available} units
                      </SociollaText>
                    ),
                    product_name: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        [{data.product.combination.reference}]{' '}
                        {data.product.name}
                      </SociollaText>
                    ),
                  }}
                />
              ) : activeTab == 'product' ? (
                <TableMobile
                  searchKey="keyword_product"
                  placeholder="Search by name"
                  useLegendList={false}
                  headerComponent={<View style={{ height: 16 }} />}
                  searchValue={productSearchValue}
                  loading={getSalesmanProducts?.loading}
                  skip={skipProduct}
                  limit={paramsState.limit}
                  tableData={products}
                  totalData={productsTotal}
                  footerComponent={true}
                  loadingPagination={loadingPaginationProducts}
                  onSearch={(val) => doSearchProduct(val, skipProduct)}
                  onLoadMore={(val) => onLoadMoreProducts(val)}
                  withLoadMore={true}
                  renderItem={({ data, index }) => (
                    <TouchableOpacity
                      activeOpacity={0.6}
                      style={styles.productItem}
                      key={index}>
                      <Image
                        style={{ width: 36, height: 36, marginRight: 20 }}
                        width={36}
                        height={36}
                        source={
                          data?.product?.image ? data?.product?.image : img
                        }
                      />
                      <View style={styles.productDesc}>
                        <View style={{ flexDirection: 'row' }}>
                          <SociollaText type="medium" style={{ fontSize: 15 }}>
                            [
                            {data?.product?.combination?.reference
                              ? data?.product?.combination?.reference
                              : '-'}
                            ] {data?.product?.name ? data?.product?.name : '-'}
                          </SociollaText>
                        </View>
                        <SociollaText
                          style={{
                            color: Colors.grey13,
                            marginVertical: 10,
                          }}>
                          {data?.stock_available ? data?.stock_available : '0'}{' '}
                          units
                        </SociollaText>
                        <Combination combination={data?.product?.combination} />
                      </View>
                    </TouchableOpacity>
                  )}
                />
              ) : (
                false
              )}
            </View>
            {isWeb ? (
              <View
                style={{
                  width: '100%',
                  backgroundColor: Colors.grey4,
                  paddingHorizontal: 20,
                  paddingVertical: 12,
                }}>
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: isWeb ? 16 : 13,
                    letterSpacing: 0.5,
                    color: Colors.grey1,
                  }}>
                  LOGS
                </SociollaText>
              </View>
            ) : (
              false
            )}
            <View
              style={{
                width: '100%',
                paddingHorizontal: isWeb ? 30 : 0,
                ...(isWeb ? { paddingVertical: 20 } : {}),
              }}>
              {isWeb ? (
                <Table
                  name="product_log"
                  structures={logTableStructure}
                  loading={getSalesmanLogs?.loading}
                  data={logs}
                  searchKey="keyword_log"
                  showFilter={false}
                  searchPlaceholder="Search by name"
                  searchValue={logSearchValue}
                  searchWidth={460}
                  hasNoHide={true}
                  hasCallback={true}
                  totalData={logsTotal}
                  skip={skipLog}
                  limit={paramsState.limit}
                  onSearch={(val) => doSearchLog(val, skipLog)}
                  onLoadMore={async (val) => {
                    setSkipLog(val);
                    await doSearchLog(logSearchValue, val);
                  }}
                  slot={{
                    date: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        {parseDate(data.created_at)} <br />
                        {parseDate(data.created_at, 'HH:mm:ss')}
                      </SociollaText>
                    ),
                    add: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        {data.log_type == 'add'
                          ? `${data.quantity} units`
                          : '-'}
                      </SociollaText>
                    ),
                    return: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        {data.log_type == 'return'
                          ? `${data.quantity} units`
                          : '-'}
                      </SociollaText>
                    ),
                    order: ({ data, index }) => (
                      <SociollaText key={`reference-${index}`}>
                        {data.log_type == 'sales_order'
                          ? `${data.quantity} units`
                          : '-'}
                      </SociollaText>
                    ),
                  }}
                />
              ) : activeTab == 'log' ? (
                <TableMobile
                  searchKey="keyword_log"
                  placeholder="Search by name"
                  useLegendList={false}
                  headerComponent={<View style={{ height: 16 }} />}
                  searchValue={logSearchValue}
                  loading={getSalesmanLogs?.loading}
                  skip={skipLog}
                  limit={paramsState.limit}
                  tableData={logs}
                  totalData={logsTotal}
                  footerComponent={true}
                  loadingPagination={loadingPaginationLogs}
                  onSearch={(val) => doSearchLog(val, skipLog)}
                  onLoadMore={(val) => onLoadMoreLogs(val)}
                  withLoadMore={true}
                  renderItem={({ data, index }) => (
                    <TouchableOpacity
                      activeOpacity={0.6}
                      style={styles.logItem}
                      key={index}>
                      <View style={{ flexDirection: 'row', width: '80%' }}>
                        <Image
                          style={{ width: 36, height: 36, marginRight: 20 }}
                          width={36}
                          height={36}
                          source={
                            data?.product?.image ? data?.product?.image : img
                          }
                        />
                        <SociollaText type="medium" style={{ fontSize: 15 }}>
                          [
                          {data?.product?.combination?.reference
                            ? data?.product?.combination?.reference
                            : '-'}
                          ] {data?.product?.name ? data?.product?.name : '-'}
                        </SociollaText>
                      </View>
                      <View
                        style={{ flexDirection: 'row', marginVertical: 10 }}>
                        <View style={styles.logSection}>
                          <SociollaText
                            type="medium"
                            style={{ marginBottom: 5 }}>
                            Order
                          </SociollaText>
                          <SociollaText>
                            {data.log_type == 'sales_order'
                              ? `${data.quantity} units`
                              : '-'}
                          </SociollaText>
                        </View>
                        <View style={styles.logSection}>
                          <SociollaText
                            type="medium"
                            style={{ marginBottom: 5 }}>
                            {['add', 'return'].includes(data.log_type)
                              ? data.log_type == 'add'
                                ? 'Add Inventory'
                                : 'Return Inventory'
                              : 'Inventory'}
                          </SociollaText>
                          <SociollaText>
                            {data.log_type == 'sales_order'
                              ? '-'
                              : `${data.quantity} units`}
                          </SociollaText>
                        </View>
                      </View>
                      <SociollaText type="medium" style={{ marginBottom: 10 }}>
                        Date Created
                      </SociollaText>
                      <View style={{ flexDirection: 'row' }}>
                        <View style={{ width: fullWidth - 150 }}>
                          <View style={{ flexDirection: 'row' }}>
                            <Image
                              style={{
                                width: 23,
                                height: 16,
                                marginLeft: -5,
                                marginRight: 5,
                              }}
                              width={23}
                              height={16}
                              svg={true}
                              source={require('@assets/img/icons/menu/calendar.svg')}
                            />
                            <SociollaText
                              style={{ fontSize: 12, color: Colors.grey2 }}>
                              {data.created_at
                                ? parseDate(
                                    data.created_at,
                                    'd MMMM yyyy | HH:mm:ss',
                                  )
                                : '-'}
                            </SociollaText>
                          </View>
                        </View>
                        <View>
                          <StatusBadge status={data.status} />
                        </View>
                      </View>
                    </TouchableOpacity>
                  )}
                />
              ) : (
                false
              )}
            </View>
          </Layout.Wrapper>
        </>
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
  },
  sectionWrapper: { width: '100%', padding: 10 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  tabContainer: {
    width: '100%',
    paddingVertical: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 5,
    zIndex: 10,
  },
  tabItem: {
    width: '50%',
    paddingVertical: 10,
    borderBottomColor: Colors.grey7,
    borderBottomWidth: 2,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemText: {
    fontSize: 13,
    color: Colors.grey1,
    textAlign: 'center',
  },
  tabItemTextActive: {
    color: Colors.black0,
  },
  productItem: {
    paddingVertical: 10,
    marginHorizontal: 20,
    borderBottomColor: Colors.grey7,
    borderBottomWidth: 1,
    flexDirection: 'row',
  },
  productDesc: {
    width: '85%',
  },
  logItem: {
    paddingVertical: 10,
    marginHorizontal: 20,
    borderBottomColor: Colors.grey7,
    borderBottomWidth: 1,
  },
  logSection: {
    width: '50%',
  },
});

export default InventorySummaryDetailScreen;
